import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { pillarArticles } from '@/mocks/pillarArticles';

export default function PillarArticles() {
  const { t, i18n } = useTranslation();
  const raw = (i18n.language || 'pt').split('-')[0];
  const lang = raw === 'en' || raw === 'de' ? raw : 'pt';

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              {t('pillars.title')}
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
              {t('pillars.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {pillarArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/${lang}/guide/${article.slug}`}
                className="group flex flex-col p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                    <i className={`${article.icon} text-primary-600 text-lg`} />
                  </div>
                  <span className="text-xs font-semibold tracking-widest text-foreground-400 uppercase">
                    Pillar Guide
                  </span>
                </div>
                <h3 className="font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-700 transition-colors">
                  {article.title[lang]}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1 line-clamp-3">
                  {article.summary[lang]}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700">
                  {t('pillars.readMore')}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}